import { Dealer } from '../dealer';
import { UUID } from '../uuid';
export class DealerForm {
  public id: UUID;
  public name: string;
  public is_active: boolean;
  constructor(model: Dealer) {
    this.id = model.id;
    this.name = model.name;
    this.is_active = model.is_active;
  }
}
